import React, { Component } from 'react';
import HomeGrid from "../home_grid/home_grid";
import "./home_page_desktop.scss";
import HomePageDesktopFooter from "../home_page_desktop_footer/home_page_desktop_footer";
import HomePageDesktopSocials from "../home_page_desktop_socials/home_page_desktop_socials";
import HomePageDesktopMessage from "../home_page_desktop_message/home_page_desktop_message";

/**
 * The Home page of the luiss.it website when it is shown on desktop.
 *
 * The page renders a full screen grid of contents on desktop;
 * the grid is continuously moving and when the user sees contents near its borders,
 * it automatically adds new row and column to make it appear infinite.
 * When the user is near the top border of the page, the grid rotates.
 *
 */
class HomePageDesktop extends Component {
    constructor(props) {
        super(props);
        // At the beginning the modal is closed and we see the contents grid
        this.state = {
            gridAnimationStarted: false
        };
    }

    componentDidMount() {
        this.setState({
            gridAnimationStarted: true
        });
    }

    /**
     * When the user click on a grid square, we show its content
     * @param content - the content to be shown
     */
    squareSelected(content) {
        this.props.navigate(content.url);
    }

    render() {
        return (
            <div id="home-page" className="desktop">

                {this.props.cards && this.props.cards.length && this.props.cards.length > 0 &&

                    <HomeGrid contents={this.props.cards} firstAnimationStarted={this.state.gridAnimationStarted}
                        squareSelected={(content) => this.squareSelected(content)} />
                }
                {this.props.banners && this.props.banners.length && <HomePageDesktopMessage {...this.props} />}
                <HomePageDesktopSocials />
                <HomePageDesktopFooter />
            </div>
        )
    }
}

export default HomePageDesktop;
